import _Array$isArray from "../../core-js/array/is-array";
export default function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}